import {
    Alert,
    Button,
    Center,
    Group,
    Loader,
    Paper,
    SegmentedControl,
    Stack,
    Title,
} from '@mantine/core'
import {Link} from '@tanstack/react-router'

import {businessCalendarDate} from 'src/api/business-time'
import {useMineOrAll} from 'src/lib/use-mine-or-all'

import {ActiveRentalsTable} from './active-rentals-table'
import {activeRentalsCsvFilename} from './export-active-rentals-csv'
import {useActiveRentals} from './use-active-rentals'

export function ActiveRentalsPage() {
    const [scope, setScope] = useMineOrAll('active-rentals', (user) =>
        user.isSalesRep ? 'mine' : 'all',
    )
    const {
        data: rows = [],
        isLoading,
        error,
    } = useActiveRentals({
        mine: scope === 'mine',
        yardId: null,
    })

    return (
        <>
            <Group justify="space-between" mb="md">
                <Title order={1}>Active rentals</Title>
                <Button component={Link} to="/projects" size="sm" variant="outline">
                    View all orders
                </Button>
            </Group>
            <Stack gap="md">
                <Paper withBorder p="sm" radius="md">
                    <SegmentedControl
                        aria-label="Whose rentals"
                        size="sm"
                        value={scope}
                        onChange={(value) => setScope(value === 'mine' ? 'mine' : 'all')}
                        data={[
                            {value: 'mine', label: 'Mine'},
                            {value: 'all', label: 'All'},
                        ]}
                    />
                </Paper>
                {isLoading ? (
                    <Center py="xl">
                        <Loader aria-label="Loading active rentals" />
                    </Center>
                ) : error ? (
                    <Alert color="red" title="Could not load active rentals">
                        {error.message}
                    </Alert>
                ) : (
                    <ActiveRentalsTable
                        rows={rows}
                        showRep={scope === 'all'}
                        csvFilename={activeRentalsCsvFilename(scope, businessCalendarDate())}
                    />
                )}
            </Stack>
        </>
    )
}
